import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import RawData from "./data/data.json";
import Fnav from "./components/navbars/fristNavbar/fristNavbar";
import GustNavbar from "./components/navbars/gustNavbar/guestNabar";
import UserNavbar from "./components/navbars/userNavbar/userNavbar";
import Footer from "./components/footer/footer";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Checkout from "./pages/checkout/Checkout";
import OrderSuccess from "./pages/checkout/OrderSuccess";
import MyOrders from "./pages/orders/MyOrders";

import {
  Home,
  Error,
  LogIn,
  Contact,
  About,
  Cart,
  Account,
} from "./pages/pages";

import FloatingCart from "./components/FloatingCart/FloatingCart";

function App() {
  const [Data, setData] = useState(() => {
    // Load cart from localStorage on initial load
    const savedCart = localStorage.getItem('thinktwice_cart');
    if (savedCart) {
      try {
        const parsedCart = JSON.parse(savedCart);
        return {
          ...RawData,
          Cart: parsedCart
        };
      } catch (error) {
        console.error('Error loading cart from localStorage:', error);
      }
    }
    return RawData;
  });
  
  const [theme, setTheme] = useState('light'); // 'light' or 'dark'

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem('thinktwice_cart', JSON.stringify(Data.Cart));
    } catch (error) {
      console.error('Error saving cart to localStorage:', error);
    }
  }, [Data.Cart]);

  // Apply theme class to body
  useEffect(() => {
    document.body.className = `theme-${theme}`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Admin Routes - No header/footer */}
          <Route path="/admin/login" element={<Navigate to="/home" replace />} />
          <Route path="/secure-admin-access-2025" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Public Routes - With header/footer */}
          <Route
            path="/*"
            element={
              <>
                <Fnav
                  theme={theme}
                  toggleTheme={toggleTheme}
                />

                {Data.Access ? (
                  <UserNavbar Data={Data.Cart} />
                ) : (
                  <GustNavbar Data={Data.Cart} />
                )}
                <Routes>
                  <Route path="/" element={<Home Data={Data} SetData={setData} />} />
                  <Route path="/home" element={<Home Data={Data} SetData={setData} />} />
                  <Route
                    path="/contact"
                    element={<Contact Data={Data} SetData={setData} />}
                  />
                  <Route
                    path="/login"
                    element={
                      Data.Access ? (
                        <Account Data={Data} SetData={setData} />
                      ) : (
                        <LogIn Data={Data} SetData={setData} />
                      )
                    }
                  />
                  <Route
                    path="/account"
                    element={
                      Data.Access ? (
                        <Account Data={Data} SetData={setData} />
                      ) : (
                        <LogIn Data={Data} SetData={setData} />
                      )
                    }
                  />
                  <Route path="/cart" element={<Cart Data={Data} SetData={setData} />} />
                  <Route path="/checkout" element={<Checkout Data={Data} SetData={setData} />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  <Route path="/my-orders" element={<MyOrders />} />
                  <Route path="/about" element={<About Data={Data} />} />
                  <Route path="*" element={<Error />} />
                </Routes>
                <Footer />
                <FloatingCart cartItems={Data.Cart} SetData={setData} />
              </>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
